import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { PerformanceInsightsPage } from '@confluence/performance-insights/entry-points/PerformanceInsightsPage.ts';
import { PERFORMANCE_INSIGHTS } from '@confluence/named-routes/entry-points/routes.ts';

export const PerformanceInsightsRoute = () => <PerformanceInsightsPage />;

PerformanceInsightsRoute.NAVIGATION_PARAMS = ({ params: { tab } }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'performanceInsightsScreen',
			attributes: {
				tab,
			},
		},
		pageState: {
			routeName: PERFORMANCE_INSIGHTS.name,
			tab,
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
